import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_DETACH_GOOGLE__SUCCESS,
  ACTION_DETACH_TWITTER__SUCCESS,

  ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS,
} from '../actionTypes';


const attachedSocialNetworks = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS:
    case ACTION_DETACH_GOOGLE__SUCCESS:
    case ACTION_DETACH_TWITTER__SUCCESS:
      return action.payload.data.snTypeToSnUserIdMap;

    default:
      return state;
  }
};

export default combineReducers({
  attachedSocialNetworks,
  errors,
});
